import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Row, Col, Card } from 'antd';
import VideoUpload from './VideoUpload';
import List from './list';
import request from '../../../../../logic/utils/request';

function BoardVideos({ showError, preloader }) {
  // const [title, setTitle] = useState(undefined);
  const [videos, setVideos] = useState([]);
  const [maxVideoSize, setMaxVideoSize] = useState(50); // По умолчанию 50MB

  const getVideos = useCallback(async () => {
    preloader();
    try {
      axios({
        method: 'get',
        url: '/api/videos',
      })
        .then((res) => setVideos(res.data));
      preloader();
    } catch (e) {
      preloader();
      showError(e.data.error);
    }
  }, [showError, preloader]);

  const getServerParams = async () => {
    try {
      const newParams = await request('/server/api/officeparams/', 'get');
      const { data: { data: paramsData } } = newParams;
      paramsData.forEach((el) => {
        if (el.param === 'maxSizeVideo') {
          console.log('el.value', el.value);
          setMaxVideoSize(parseInt(el.value, 10) || 50);
        }
      });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('e === ', e);
      // Если не удалось получить параметры, оставляем значение по умолчанию
    }
  };

  useEffect(() => {
    getVideos();
    getServerParams();
  }, [getVideos]);

  const uploadVideo = async () => {
    // Видео уже загружено, просто обновляем список
    getVideos();
  };

  const deleteVideo = async (id) => {
    preloader();
    try {
      await axios({
        method: 'delete',
        url: '/api/videos',
        data: {
          id,
        },
      });
      preloader();
      getVideos();
      toast.success('Удалено');
    } catch (e) {
      preloader();
      showError(e.data.text);
    }
  };
  const setShow = async (id) => {
    preloader();
    try {
      await axios({
        method: 'patch',
        url: '/api/videos',
        data: {
          id,
        },
      });
      preloader();
      getVideos();
      toast.success('Выполнено');
    } catch (e) {
      preloader();
      showError(e.data.text);
    }
  };

  console.log(maxVideoSize);
  return (
    <Row gutter={[24, 24]}>
      <Col span={8}>
        <Card bordered={false}>
          <VideoUpload
            save={uploadVideo}
            showError={showError}
            maxVideoSize={maxVideoSize}
          />
        </Card>
      </Col>
      <Col span={16}>
        <List deleteVideo={deleteVideo} setShow={setShow} videos={videos} />
      </Col>
    </Row>
  );
}

export default BoardVideos;
